/** Sanction-order deductions that have no reconciliation menu yet. Listing only. */
export const DEDUCTION_LISTINGS = [
    {
        path: '/additional-royalty',
        title: 'Additional Royalty',
        apiFlag: 'additional_royalty',
        amountField: 'additional_royalty_amount',
        amountHeader: ['Additional Royalty', 'Amount'],
    },
    {
        path: '/smet',
        title: 'SMET',
        apiFlag: 'smet',
        amountField: 'smet_amount',
        amountHeader: ['SMET', 'Amount'],
    },
    {
        path: '/penalty-in-deduction',
        title: 'Penalty in Deduction',
        apiFlag: 'penalty_in_deduction',
        amountField: 'penalty_in_deduction_amount',
        amountHeader: ['Penalty in Deduction', 'Amount'],
    },
    {
        path: '/restoration',
        title: 'Restoration',
        apiFlag: 'restoration',
        amountField: 'restoration_amount',
        amountHeader: ['Restoration', 'Amount'],
    },
    {
        path: '/stamp-duty',
        title: 'Stamp Duty',
        apiFlag: 'stamp_duty',
        amountField: 'stamp_duty_amount',
        amountHeader: ['Stamp Duty', 'Amount'],
    },
    {
        path: '/dmft',
        title: 'DMFT',
        apiFlag: 'dmft',
        amountField: 'dmft_amount',
        amountHeader: ['DMFT', 'Amount'],
    },
    {
        path: '/security-deposit',
        title: 'Security Deposit',
        apiFlag: 'security_deposit',
        amountField: 'security_deposit_amount',
        amountHeader: ['Security Deposit', 'Amount'],
    },
];
